import React from 'react';
import styles from './A_CircleButton.module.css';
import cn from 'classnames';

interface A_CircleButtonProps {
  icon: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'glass' | 'transparent';
  size?: 'small' | 'large';
  onClick: () => void;
}

export default function A_CircleButton({
  icon,
  variant = 'primary',
  size = 'large',
  onClick,
}: A_CircleButtonProps) {
  return (
    <button
      className={cn(
        styles.wrapper,
        styles[variant],
        styles[size],
        variant === 'glass' && 'effect-glass'
      )}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}
